import { api } from 'common';

export function getDefaultSchedulingConfigs() {
  return {
    schedulingConfigsState: api.FlowDefinition.FormBlockSchedulingConfigsState.Disabled,
    practiceType: api.FlowDefinition.FormBlockPracticeType.StaticList,
    practiceIds: [],
    providerType: api.FlowDefinition.FormBlockProviderType.StaticList,
    providerIds: [],
    fhirDynamicProviders: [],
    scheduleAppointmentCallSectionEnabled: false,
    scheduleAppointmentCommentEnabled: false,
  };
}
